import {
  CameraCapabilityDto,
  CommunicationState,
  Preset,
  PtzLockInfo,
  VideoRecord,
  VideoStream,
} from '@kinetic-ui/data-layer';

export enum VideoPlayerFunctionality {
  PUBLIC_FEED = 'publicFeed',
  CAMERA_LOCK = 'cameraLock',
  IRIS_CONTROL = 'irisControl',
  FOCUS_CONTROL = 'focusControl',
  CAPABILITIES = 'capabilities',
  PTZ = 'ptz',
  PAUSE_TOUR = 'pauseTour',
  RECORDING = 'recording',
  SETTINGS = 'settings',
  PRESET_CONTROL = 'presetControl',
  SCREEN_LAYOUT_CONTROL = 'screenLayoutControl',
  DETECTIONS = 'detections',
}

export interface VideoCommunicationParameters {
  EXTERNAL_ID?: string;
  API_KEY?: string;
  USERNAME?: string;
  PASSWORD?: string;
}

// TODO Tech debt: remove this interface and use type from generated/graphql
export interface VideoPlayerCamera {
  id: string;
  name: string;
  communicationStatus?: CommunicationState;
  poweredOn?: boolean;
  road?: string;
  autoFocusEnabled?: boolean;
  autoIrisEnabled?: boolean;
  privateStreamRecordingInProgress?: boolean;
  direction?: string;
  description?: string;
  location?: any;
  locationDescription?: string;
  userNotes?: string;
  referencePoint?: string;
  publicFeedEnabled?: boolean;
  presets?: Preset[];
  ptzLock: PtzLockInfo;
  streams?: VideoStream[];
  tours?: Array<{ id: string; name: string }>;
  capabilities?: CameraCapabilityDto[];
  capabilitiesState: any;
  communicationParameters?: VideoCommunicationParameters;
  liveRecordings?: VideoRecord[];
}
